import React, { useState, useMemo, useEffect } from 'react';
import { Grid, TextField, Checkbox, CircularProgress, Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { CustomTable } from '../../../../common/Tables/CustomTable/CustomTable';
import { ContractPermissionsSlider } from './ContractPermissionsSlider/ContractPermissionsSlider';
import { integerToPermissions, permissionsToInteger, permissionsNamesSpanish } from '../../../../../helpers/permissions';
import { typeToInteger, contractTypesNames, integerToType } from '../../../../../helpers/type';
import { checkUserContracts } from '../../../../../hooks/useCheckUserContracts';
export const AddToContractsList = ({ onSelectedContractsChange, showSearch = true, userId }) => {
    // Obtener contratos desde Redux
    const contracts = useSelector((state) => state.contracts.contracts);
    const [search, setSearch] = useState('');
    const [selectedContracts, setSelectedContracts] = useState([]);
    const [targetUserContracts, setTargetUserContracts] = useState(null); //son los contratos a los que tiene acceso el usuario a modificar (target)


    useEffect(() => {
        const fetchUserContracts = async () => {
            try {
                const contracts = await checkUserContracts(userId);
                setTargetUserContracts(contracts);

            } catch (error) {
                console.error("Error loading user contracts:", error);
            }
        };
        if (userId && userId !== "undefined") {
            fetchUserContracts();
        }
        else {

            setTargetUserContracts([]);
        }
    }, [userId]);

    useEffect(() => {
        onSelectedContractsChange && onSelectedContractsChange(selectedContracts);
    }, [selectedContracts, onSelectedContractsChange]);

    const handlePermissionChange = (contractId, numericValue) => {
        const permission = integerToPermissions(numericValue);
        setSelectedContracts(prev =>
            prev.map(contract => contract.id === contractId ? { ...contract, permissions: permission } : contract)
        );
    };

    const handleTypeChange = (contractId, numericValue) => {
        const type = integerToType(numericValue);

        setSelectedContracts(prev =>
            prev.map(contract => {

                return contract.id === contractId ? { ...contract, type: type } : contract
            })
        );
    };





    const handleSelect = (contract, isChecked) => {
        setSelectedContracts((prevSelected) =>
            isChecked
                ? [...prevSelected, contract]
                : prevSelected.filter((selected) => selected.id !== contract.id)
        );
    };

    const handleInputChange = (event) => {
        setSearch(event.target.value);
    };

    const filterContractsByUserContracts = (contracts, targetUserContracts) => {
        if (!targetUserContracts) return [];
        return contracts?.filter((contract) => {
            return !targetUserContracts.some((targetContract) => targetContract.id === contract.id);
        });
    };

    const filteredData = useMemo(() => {
        const contractsFiltered = filterContractsByUserContracts(contracts, targetUserContracts);
        return contractsFiltered.filter((contract) =>
            search.length === 0
                ? true
                : ['name', 'type', 'id'].some((key) =>
                    String(contract[key] || '')
                        .toLowerCase()
                        .includes(search.toLowerCase())
                )
        );
    }, [contracts, search, targetUserContracts]);




    const columns = [
        { id: 'select', label: '', minWidth: 50 },
        { id: 'id', label: 'ID Contrato', minWidth: 100 },
        { id: 'name', label: 'Nombre del Contrato', minWidth: 180 },
        {
            id: 'permissions', label: 'Permisos', minWidth: 250, render: (value, row) => (
                <ContractPermissionsSlider
                    row={row}
                    selectedContracts={selectedContracts}
                    marksNames={permissionsNamesSpanish}
                    fieldName="permissions"
                    fieldToInteger={permissionsToInteger}
                    handleChange={handlePermissionChange}
                />
            )
        },
        {
            id: 'type', label: 'Tipo de Contrato', minWidth: 220, render: (value, row) => (
                <ContractPermissionsSlider
                    row={row}
                    selectedContracts={selectedContracts}
                    marksNames={contractTypesNames}
                    fieldName="type"
                    fieldToInteger={typeToInteger}
                    handleChange={handleTypeChange}
                />
            )
        },
    ];
    return (
        targetUserContracts === null ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 4 }}>
                <CircularProgress />
            </Box>
        ) : (
            <Grid container spacing={2} className="animate__animated animate__fadeIn animate__fast">
                {showSearch && (
                    <Grid item sm={5}>
                        <TextField
                            id="search"
                            label="Busca un contrato"
                            type="search"
                            name="search"
                            autoComplete="off"
                            value={search}
                            onChange={handleInputChange}
                            fullWidth
                        />
                    </Grid>
                )}
                <Grid item style={{ width: '100%', marginTop: '16px' }}>
                    <CustomTable
                        rows={filteredData.map((contract) => ({
                            ...contract,
                            select: (
                                <Checkbox
                                    checked={selectedContracts.some((selected) => selected.id === contract.id)}
                                    onChange={(event) => handleSelect(contract, event.target.checked)}
                                />
                            ),
                        }))}
                        columns={columns}
                    />
                </Grid>
            </Grid>
        )
    );
}

AddToContractsList.propTypes = {
    onSelectedContractsChange: PropTypes.func,
    showSearch: PropTypes.bool,
};
